import { observer } from 'mobx-react';
import * as React from 'react';
import { components } from 'react-select';
import { backgroundColor, isMulti, isRequired, placeholder, prepOnChange, Value } from '..';
import SelectForTS from '../../../../../SelectForTS';
import { isReadonly, SelectionOption, SelectionsField } from '../../../Types';
import { createCustomOption } from '../CustomOption';

interface Props {
  field: SelectionsField;
  onChange: (value: Value) => void;
  options: ReadonlyArray<SelectionOption>;
  dataIntercomTarget?: string;
}

const Synchronous: React.FC<Props> = ({ field, onChange, options, dataIntercomTarget }) => {
  const CustomOption = React.useMemo(
    () => (dataIntercomTarget ? createCustomOption(dataIntercomTarget) : components.Option),
    [dataIntercomTarget],
  );

  return (
    <SelectForTS<SelectionOption>
      name={field.name}
      isSearchable={false}
      isMulti={isMulti(field)}
      options={options.slice(0)}
      value={field.value}
      isDisabled={isReadonly(field)}
      isClearable={!isRequired(field)}
      placeholder={placeholder(field)}
      onChange={prepOnChange(onChange)}
      aria-label={field.label.getOrElseValue(field.name)}
      components={{
        IndicatorSeparator: () => null,
        Option: CustomOption,
      }}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          fontSize: '0.875rem',
          fontWeight: '500',
          borderColor: state.isFocused ? '#187A90' : '#BEC0C5',
          cursor: state.isDisabled ? 'not-allowed' : 'default',
          '&:hover': {
            borderColor: '#187A90',
            color: '#187A90',
          },
        }),
        option: (styles, { isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor: backgroundColor(isFocused, isSelected),
            color: isSelected ? 'white' : 'black',
            fontSize: '0.875rem',
            fontWeight: '500',
          };
        },
      }}
    />
  );
};

export default observer(Synchronous);
